module.exports = __webpack_public_path__ + "media/images/mobile/home/banner3-5431f439893013e8762ec155c5e222a8.jpg";